




















































































































































































































































































































import { isEmpty } from 'lodash';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import navMenuItems from './navMenuItems.js';
import QThrottleDialog from './components/QThrottleDialog.vue';
import QTour from '@/components/QTour.vue';
import QDialog from './components/QDialog.vue';
import QHelpCenter from './components/QHelpCenter.vue';
import { showWelcomeInstruction } from '@/utils/business';
import { abortController } from '../http/requests/v1';
import QFeedbackPopup from '@/components/QFeedbackPopup/QFeedbackPopup.vue';

@Component({
  components: {
    QThrottleDialog,
    QTour,
    QDialog,
    QHelpCenter,
    QFeedbackPopup,
  },
  computed: {
    ...mapState('Auth', {
      user: 'user',
      activeRoleKey: 'activeRoleKey',
      isImpersonate: 'isImpersonate',
    }),
    ...mapGetters('Auth', {
      userRole: 'userRole',
    }),
    ...mapState('Tour', {
      tourName: 'name',
      tourSteps: 'steps',
    }),
    ...mapState({
      mode: 'mode',
      reload: 'reload',
      loading: 'loading',
      snackbar: 'snackbar',
    }),
  },
})
export default class MainLayout extends Vue {
  disabledActions = [];
  triggeredActionIndex = -1; // the index for the app bar action that is triggered and running a request
  drawer = true;
  leaveDialog = false;
  prevRoute: {
    name: string;
    params: any;
    meta: Record<string, string>;
  } | null = null;
  tmpActions = null; // to override the app bar actions array
  showHelp = false;
  publicPath = process.env.BASE_URL;

  userRole!: string;
  loading!: boolean;
  activeRoleKey!: string;
  isImpersonate!: boolean;
  mode!: string;
  tourName!: string;
  tourSteps!: [];

  get navMenuItems() {
    return navMenuItems;
  }

  get appBarActions() {
    return this.$route.meta.appBarActions
      ? this.$route.meta.appBarActions(this.tmpActions)
      : [];
  }

  get triggeredAction() {
    if (this.triggeredActionIndex === -1 || isEmpty(this.appBarActions)) {
      return null;
    }
    return this.appBarActions[this.triggeredActionIndex];
  }

  get isBusinessRole() {
    return this.activeRoleKey === 'rBusiness';
  }

  get isStaging() {
    return this.mode === 'staging';
  }

  get footerText() {
    let text = '© WHA Screening Pty Ltd ' + new Date().getFullYear() + '.';
    if (this.isStaging) {
      text = '[!!! Dev !!!] ' + text;
    }
    return text;
  }

  beforeMount() {
    if (window.innerWidth <= 600) {
      this.drawer = false;
    } else {
      this.drawer = !this.$route.meta.hideNav;
    }
  }

  @Watch('$route')
  watchRoute(to, from) {
    this.triggeredActionIndex = -1;
    this.disabledActions = [];
    this.tmpActions = null;
    this.prevRoute = from;
    if (window.innerWidth <= 600) {
      this.drawer = false;
    } else {
      this.drawer = !to.meta.hideNav;
    }

    if (this.tourSteps.length > 0) {
      this.$store.dispatch('Tour/stop', { tours: this.$tours });
    }

    abortController.controller.abort();
  }

  @Watch('loading')
  watchLoading(loading) {
    // if the triggeredActionIndex is greater than -1, which means a app bar action button is clicked and running an API request
    // if the loading is false, which means the triggered app bar action is done
    // if the appBarActions exists, which mean there are action buttons on the app bar
    if (this.triggeredActionIndex > -1 && !loading && this.appBarActions) {
      // Ensure the triggered action button exists on app bar and also allow redirect
      if (
        this.appBarActions[this.triggeredActionIndex] &&
        this.appBarActions[this.triggeredActionIndex].redirect
      ) {
        // Go back to previous page after the API request is done
        this.handleRedirectRequest();
      }
    }
  }

  /**
   * use spread operator to make parameter flexible, so we can add parametors as many as we want,
   * and use it (payload) as an array variable
   */
  handleAction(action, ...payload) {
    switch (action) {
      // handle route redirect action
      case 'redirect':
        this.handleRedirectRequest(payload[0]);
        break;
      // handle page request action such as CREATE, READ, UPDATE, DELETE actions defined in CRUDMixins
      case 'page':
        this.handlePageRequest(payload[0]);
        break;
      // handle route request action with a confirmation dialog
      case 'leaveWithDialog':
        this.leaveDialog = !this.leaveDialog;
        if (!this.leaveDialog) {
          this.handleRedirectRequest();
        }
        break;
      case 'leave':
        this.handleRedirectRequest();
        break;
      // hanlde logout
      case 'logout':
        this.$store.dispatch('Auth/logout', this.activeRoleKey);
        break;
      // handle stop impersonate
      case 'stop-impersonate':
        this.$store.dispatch('Auth/stopImpersonate');
    }
  }

  handleRedirectRequest(route?) {
    if (route) {
      return this.$router.push(route);
    }

    return this.goBack();
  }

  goBack() {
    if (this.prevRoute && this.prevRoute.name) {
      let prevRouteName = this.prevRoute.name;
      if (
        prevRouteName.includes('create') ||
        prevRouteName.includes('update')
      ) {
        prevRouteName = prevRouteName
          .replace('create', 'list')
          .replace('update', 'list');
      }
      return this.$router.push({
        name: prevRouteName,
        params: this.prevRoute.params,
      });
    }

    if (this.userRole) {
      return this.$router.push({
        name: this.userRole.toLowerCase() + '-dashboard',
      });
    }
  }

  handlePageRequest(index = 0) {
    this.triggeredActionIndex = index;
    this.$store.dispatch('callAction', this.triggeredAction.name);
  }

  toBookingCreate() {
    if (this.$route.name && this.$route.name === 'business-booking-create') {
      return;
    }
    this.$router.push({ name: 'business-booking-create' });
  }

  goProfile() {
    const activeRoleKey = this.activeRoleKey;
    let routeName = 'login';
    switch (activeRoleKey) {
      case 'rAdmin':
        routeName = 'administrator-user-profile';
        break;
      case 'rBusiness':
        routeName = 'business-user-profile';
        break;
      case 'rCandidate':
        routeName = 'candidate-user-profile';
        break;
      default:
        break;
    }
    this.$router.push({
      name: routeName,
    });
  }

  canDisplay(navItem) {
    const hasACL = !!navItem.acl;
    const hasDisplayRules = !!navItem.display_rules;
    // if no ACL and no display rules, display the nav item
    if (!hasACL && !hasDisplayRules) {
      return true;
    }

    // if has ACL and no display rules, check ACL
    if (hasACL && !hasDisplayRules) {
      return this.$acl.check(navItem.acl);
    }

    // if no ACL and has display rules, check display rules
    if (!hasACL && hasDisplayRules) {
      return this.checkDisplayRules(navItem.display_rules);
    }

    // if has both ACL and display rules, check both
    return (
      this.$acl.check(navItem.acl) &&
      this.checkDisplayRules(navItem.display_rules)
    );
  }

  checkDisplayRules(displayRules) {
    // Check vuex state whether match the display rule or not
    return displayRules.every((displayRule) => {
      // check by including
      if (displayRule.operator === 'includes') {
        return this.$store.state[`${displayRule.module}`]?.[
          `${displayRule.state}`
        ]?.[displayRule.attribute].includes(displayRule.value);
      }

      // check by comparing
      return (
        this.$store.state[`${displayRule.module}`]?.[`${displayRule.state}`]?.[
          displayRule.attribute
        ] === displayRule.value
      );
    });
  }

  enableQuickDashboardTour() {
    if (this.$route.name !== 'business-dashboard') {
      // Remove local storage data to enable the tours
      localStorage.removeItem('step_by_step_guides');
      this.$router.push({
        name: 'business-dashboard',
      });
    } else {
      showWelcomeInstruction(this.$tours);
    }
  }
}
